'use strict';

var _ = require('lodash');
var UserExclusionsToolbarController = function UserExclusionsToolbarController($scope, $rootScope, featureToggleService, userExclusionsToolbarBookmarksService, searchCriteriaConstantsService, userSecureService) {
  $scope.getFirstValidBookmark = function (bookmarks) {
    var bookmark = _.find(bookmarks, function (item) {
      return userSecureService.hasAuthorization(item.value);
    });
    return bookmark && bookmark.value;
  };
  $scope.setupBookmarks = function () {
    $scope.bookmarks = userExclusionsToolbarBookmarksService.getBookmarks();
    $scope.selectedBookmark = $scope.getFirstValidBookmark($scope.bookmarks);
  };
  $scope.setupBookmarks();
  $scope.$watch('selectedBookmark', function () {
    $rootScope.$broadcast('user-exclusions:modeChanged', $scope.selectedBookmark);
  });
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.isSearchButtonVisible = function () {
    return false;
  };
};
UserExclusionsToolbarController.$inject = ['$scope', '$rootScope', 'FeatureToggleService', 'UserExclusionsToolbarBookmarksService', 'SearchCriteriaConstantsService', 'UserSecureService'];
module.exports = UserExclusionsToolbarController;